(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["band-product-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.czalo').forEach(function (root) {
      var sid = root.dataset.sectionId;
      var dataEl = document.querySelector('[data-czalo-variants="' + sid + '"]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var optGroups = root.querySelectorAll('[data-czalo-option]');
      var priceEls = root.querySelectorAll('[data-czalo-price]');
      var idInput = root.querySelector('[data-czalo-variant-id]');
      var atc = root.querySelector('[data-czalo-atc]');
      var atcText = root.querySelector('[data-czalo-atc-text]');
      var form = root.querySelector('[data-czalo-form], form.czalo-form');
      var atcDefault = atcText ? atcText.textContent.trim() : 'Add to Bag';

      /* refresh cart count bubbles + notify theme */
      function refreshCartUI() {
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var count = cart.item_count;
            /* CIZARO header cart badge — create it if the cart started empty */
            document.querySelectorAll('.cz-header__cart-btn').forEach(function (cartBtn) {
              var badge = cartBtn.querySelector('.cz-header__badge');
              if (!badge) {
                badge = document.createElement('span');
                badge.className = 'cz-header__badge';
                cartBtn.appendChild(badge);
              }
              badge.textContent = count;
              badge.hidden = count < 1;
              badge.style.display = count < 1 ? 'none' : '';
            });
            /* generic fallbacks for other themes */
            document.querySelectorAll('[data-cart-count], .cart-count-bubble, .cart-bubble__text').forEach(function (el) {
              el.textContent = count;
            });
            document.dispatchEvent(new CustomEvent('cart:update', { detail: { cart: cart }, bubbles: true }));
          });
      }

      function addVariantToCart(variantId, onDone, onError) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            refreshCartUI();
            if (onDone) onDone();
          })
          .catch(function () {
            if (onError) onError();
          });
      }

      function selectedOptions() {
        var out = [];
        optGroups.forEach(function (g) {
          var sel = g.querySelector('.is-selected');
          out[parseInt(g.dataset.optionIndex, 10)] = sel ? sel.dataset.czaloValue : null;
        });
        return out;
      }

      function findVariant(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) {
            return opts[i] === null || opts[i] === undefined || o === opts[i];
          });
        });
      }

      function refreshAvailability() {
        var opts = selectedOptions();
        optGroups.forEach(function (g) {
          var idx = parseInt(g.dataset.optionIndex, 10);
          g.querySelectorAll('[data-czalo-value]').forEach(function (btn) {
            var test = opts.slice();
            test[idx] = btn.dataset.czaloValue;
            var v = variants.find(function (vv) {
              return vv.options.every(function (o, i) {
                return test[i] === null || test[i] === undefined || o === test[i];
              });
            });
            btn.classList.toggle('is-unavailable', !(v && v.available));
          });
        });
      }

      function applyVariant() {
        var v = findVariant(selectedOptions());
        if (!v) return;
        if (idInput) {
          idInput.value = v.id;
          /* fire change so Find-in-Store (and other listeners) resync the SKU */
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        /* keep the gallery wishlist heart pointed at the current variant */
        var heart = root.querySelector('[data-czalo-wishheart]');
        if (heart) {
          heart.dataset.variant = v.id;
          heart.dataset.price = v.price;
        }
        priceEls.forEach(function (el) {
          el.innerHTML = v.price + (v.compare_at ? ' <s>' + v.compare_at + '</s>' : '');
        });
        if (atc) {
          atc.disabled = !v.available;
          if (atcText) atcText.textContent = v.available ? atcDefault : 'Sold Out';
        }
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url);
        } catch (e) {}
        refreshAvailability();
      }

      optGroups.forEach(function (g) {
        g.querySelectorAll('[data-czalo-value]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            g.querySelectorAll('.is-selected').forEach(function (b) {
              b.classList.remove('is-selected');
            });
            btn.classList.add('is-selected');
            applyVariant();
          });
        });
      });

      refreshAvailability();

      /* ── Color swatch image filtering ── */
      var galleryEl = root.querySelector('[data-czalo-gallery]');

      function filterGalleryByColor(colorValue) {
        if (!galleryEl) return;
        var mediaItems = galleryEl.querySelectorAll('.czalo-media');
        if (!colorValue) {
          mediaItems.forEach(function (item) {
            item.style.display = '';
          });
          return;
        }
        var cDown = colorValue.toLowerCase().trim();
        var hasMatch = false;
        mediaItems.forEach(function (item) {
          var alt = (item.getAttribute('data-czalo-media-alt') || '').toLowerCase().trim();
          if (alt === cDown || alt === '') {
            item.style.display = '';
            if (alt === cDown) hasMatch = true;
          } else {
            item.style.display = 'none';
          }
        });
        /* if no images matched this color, show everything */
        if (!hasMatch) {
          mediaItems.forEach(function (item) {
            item.style.display = '';
          });
        }
        /* scroll to first visible image */
        var first = galleryEl.querySelector('.czalo-media:not([style*="display: none"])');
        if (first) first.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      /* Detect color option group: look for swatch dots (color swatches have dots, size buttons don't) */
      var colorGroup = null;
      root.querySelectorAll('[data-czalo-option]').forEach(function (g) {
        if (colorGroup) return;
        if (g.querySelector('.czalo-swatch__dot') || g.querySelector('.czalo-swatch')) {
          colorGroup = g;
        }
      });

      if (colorGroup) {
        colorGroup.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-czalo-value]');
          if (btn) {
            filterGalleryByColor(btn.dataset.czaloValue);
          }
        });
        /* apply filter on load for pre-selected color */
        var selBtn = colorGroup.querySelector('.is-selected');
        if (selBtn) {
          filterGalleryByColor(selBtn.dataset.czaloValue);
        }
      }

      /* AJAX add to cart */
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (atc && atc.disabled) return;
          var fd = new FormData(form);
          if (atcText) atcText.textContent = 'Adding…';
          fetch('/cart/add.js', { method: 'POST', body: fd })
            .then(function (r) {
              if (!r.ok) throw new Error('add failed');
              return r.json();
            })
            .then(function () {
              if (atcText) atcText.textContent = 'Added ✓';
              setTimeout(function () {
                if (atcText) atcText.textContent = atcDefault;
              }, 2000);
              refreshCartUI();
            })
            .catch(function () {
              if (atcText) atcText.textContent = 'Error — try again';
              setTimeout(function () {
                if (atcText) atcText.textContent = atcDefault;
              }, 2500);
            });
        });
      }

      /* Shop the Look progress bar */
      var track = root.querySelector('[data-czalo-stl-track]');
      var bar = root.querySelector('[data-czalo-stl-bar]');
      if (track && bar) {
        var update = function () {
          var max = track.scrollWidth - track.clientWidth;
          var ratio = track.clientWidth / track.scrollWidth;
          bar.style.width = Math.max(ratio * 100, 12) + '%';
          var progress = max > 0 ? track.scrollLeft / max : 0;
          bar.style.transform = 'translateX(' + progress * (100 / Math.max(ratio, 0.12) - 100) + '%)';
        };
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      }

      /* ── Shop the Look quick add ── */
      var qaModal = root.querySelector('[data-czalo-qamodal]');
      var qaList = qaModal ? qaModal.querySelector('[data-czalo-qa-list]') : null;

      function qaClose() {
        if (qaModal) qaModal.hidden = true;
      }

      if (qaModal) {
        qaModal.querySelectorAll('[data-czalo-qa-close]').forEach(function (el) {
          el.addEventListener('click', qaClose);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') qaClose();
        });
      }

      root.querySelectorAll('[data-czalo-qa]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var holder = btn.closest('.czalo-stl__imgwrap');
          var jsonEl = holder ? holder.querySelector('[data-czalo-stl-json]') : null;
          if (!jsonEl || !qaModal || !qaList) return;
          var data;
          try {
            data = JSON.parse(jsonEl.textContent);
          } catch (err) {
            return;
          }

          /* single default variant → add straight away, no modal */
          if (data.variants.length === 1 && data.variants[0].label === 'Default Title') {
            addVariantToCart(data.variants[0].id);
            return;
          }

          qaList.innerHTML = '';
          data.variants.forEach(function (v) {
            var row = document.createElement('button');
            row.type = 'button';
            row.className = 'czalo-qa-row' + (v.available ? '' : ' is-soldout');

            var label = document.createElement('span');
            label.textContent = v.label;
            row.appendChild(label);

            var note = document.createElement('span');
            note.className = 'czalo-qa-note';
            if (v.note) note.textContent = '- ' + v.note;
            row.appendChild(note);

            if (v.available) {
              row.addEventListener('click', function () {
                note.textContent = '- Adding…';
                addVariantToCart(
                  v.id,
                  function () {
                    note.textContent = '- Added ✓';
                    setTimeout(qaClose, 700);
                  },
                  function () {
                    note.textContent = '- Error, try again';
                  }
                );
              });
            } else {
              row.disabled = true;
            }
            qaList.appendChild(row);
          });

          qaModal.hidden = false;
        });
      });

      /* ── Order-by countdown blocks ── */
      root.querySelectorAll('[data-czalo-countdown]').forEach(function (el) {
        var cutoff = parseInt(el.dataset.cutoff, 10);
        var out = el.querySelector('[data-czalo-count]');
        if (isNaN(cutoff) || !out) return;
        function tick() {
          var now = new Date();
          var end = new Date(now);
          end.setHours(cutoff, 0, 0, 0);
          var diff = end - now;
          if (diff <= 0) {
            el.style.display = 'none';
            return;
          }
          var h = Math.floor(diff / 3600000);
          var m = Math.floor((diff % 3600000) / 60000);
          var s = Math.floor((diff % 60000) / 1000);
          out.textContent = (h > 0 ? h + 'h ' : '') + m + 'm ' + s + 's';
        }
        tick();
        setInterval(tick, 1000);
      });

      /* smooth-scroll for "Fit & Description" link → first accordion in this section */
      root.querySelectorAll('[data-czalo-scrollto]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var target = root.querySelector('.czalo-acc');
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            target.open = true;
          }
        });
      });

      /* ── Size Chart modal ── */
      root.querySelectorAll('[data-czalo-sizechart-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var modal = root.querySelector('[data-czalo-sizechart-modal]');
          if (modal) modal.setAttribute('aria-hidden', 'false');
        });
      });
      root.querySelectorAll('[data-czalo-sizechart-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          var modal = root.querySelector('[data-czalo-sizechart-modal]');
          if (modal) modal.setAttribute('aria-hidden', 'true');
        });
      });
    });

    /* ── Trust-pill modals (delegated, works for every instance) ── */
    (function () {
      function closeAll() {
        document.querySelectorAll('.czalo-tp__modal').forEach(function (m) {
          m.setAttribute('aria-hidden', 'true');
        });
      }
      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-czalo-tp-open]');
        if (opener) {
          e.preventDefault();
          var m = document.getElementById(opener.getAttribute('data-czalo-tp-open'));
          if (m) {
            closeAll();
            m.setAttribute('aria-hidden', 'false');
          }
          return;
        }
        if (e.target.closest('[data-czalo-tp-close]')) {
          e.preventDefault();
          closeAll();
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeAll();
          document.querySelectorAll('[data-czalo-sizechart-modal]').forEach(function (m) {
            m.setAttribute('aria-hidden', 'true');
          });
        }
      });
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["band-product-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.esla').forEach(function (root) {
      var sid = root.dataset.sectionId;
      var dataEl = document.querySelector('[data-esla-variants="' + sid + '"]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var optGroups = root.querySelectorAll('[data-esla-option]');
      var priceEls = root.querySelectorAll('[data-esla-price]');
      var idInput = root.querySelector('[data-esla-variant-id]');
      var atc = root.querySelector('[data-esla-atc]');
      var atcText = root.querySelector('[data-esla-atc-text]');
      var form = root.querySelector('[data-esla-form], form.esla-form');
      var atcDefault = atcText ? atcText.textContent.trim() : 'Add to Bag';

      /* refresh cart count bubbles + notify theme */
      function refreshCartUI() {
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count], .cart-count-bubble, .cart-bubble__text').forEach(function (el) {
              el.textContent = cart.item_count;
            });
            document.dispatchEvent(new CustomEvent('cart:update', { detail: { cart: cart }, bubbles: true }));
          });
      }

      function addVariantToCart(variantId, onDone, onError) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            refreshCartUI();
            if (onDone) onDone();
          })
          .catch(function () {
            if (onError) onError();
          });
      }

      function selectedOptions() {
        var out = [];
        optGroups.forEach(function (g) {
          var sel = g.querySelector('.is-selected');
          out[parseInt(g.dataset.optionIndex, 10)] = sel ? sel.dataset.eslaValue : null;
        });
        return out;
      }

      function findVariant(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) {
            return opts[i] === null || opts[i] === undefined || o === opts[i];
          });
        });
      }

      function refreshAvailability() {
        var opts = selectedOptions();
        optGroups.forEach(function (g) {
          var idx = parseInt(g.dataset.optionIndex, 10);
          g.querySelectorAll('[data-esla-value]').forEach(function (btn) {
            var test = opts.slice();
            test[idx] = btn.dataset.eslaValue;
            var v = variants.find(function (vv) {
              return vv.options.every(function (o, i) {
                return test[i] === null || test[i] === undefined || o === test[i];
              });
            });
            btn.classList.toggle('is-unavailable', !(v && v.available));
          });
        });
      }

      /* ── Color-linked gallery: show only images whose alt matches the selected color ── */
      var colorGroup = root.querySelector('[data-esla-colorgroup]');

      function filterGallery() {
        if (!colorGroup) return;
        var sel = colorGroup.querySelector('.is-selected');
        var color = sel ? (sel.dataset.eslaValue || '').toLowerCase().trim() : '';
        var medias = root.querySelectorAll('.esla-media');
        if (!medias.length) return;
        var shown = 0;
        medias.forEach(function (m) {
          var mc = (m.dataset.mediaColor || '').toLowerCase().trim();
          /* untagged images (no color alt) stay visible for every color */
          var show = !color || !mc || mc === color;
          m.classList.toggle('is-hidden', !show);
          if (show) shown++;
        });
        /* safety net: never end up with an empty gallery */
        if (shown === 0) {
          medias.forEach(function (m) {
            m.classList.remove('is-hidden');
          });
        }
        var gallery = root.querySelector('[data-esla-gallery]');
        if (gallery) gallery.scrollLeft = 0;
      }

      function applyVariant() {
        var v = findVariant(selectedOptions());
        filterGallery();
        if (!v) return;
        if (idInput) idInput.value = v.id;
        var savedLabel = root.dataset.savedLabel || 'You save';
        priceEls.forEach(function (el) {
          var html = v.price;
          if (v.compare_at) {
            html += ' <s>' + v.compare_at + '</s>';
            if (v.saved) {
              html += ' <span class="esla-saved">(' + savedLabel + ' ' + v.saved + ')</span>';
            }
          }
          el.innerHTML = html;
        });
        if (atc) {
          atc.disabled = !v.available;
          if (atcText) atcText.textContent = v.available ? atcDefault : 'Sold Out';
        }
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url);
        } catch (e) {}
        refreshAvailability();
      }

      optGroups.forEach(function (g) {
        g.querySelectorAll('[data-esla-value]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            g.querySelectorAll('.is-selected').forEach(function (b) {
              b.classList.remove('is-selected');
            });
            btn.classList.add('is-selected');
            applyVariant();
          });
        });
      });

      refreshAvailability();
      filterGallery();

      /* AJAX add to cart */
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (atc && atc.disabled) return;
          var fd = new FormData(form);
          if (atcText) atcText.textContent = 'Adding…';
          fetch('/cart/add.js', { method: 'POST', body: fd })
            .then(function (r) {
              if (!r.ok) throw new Error('add failed');
              return r.json();
            })
            .then(function () {
              if (atcText) atcText.textContent = 'Added ✓';
              setTimeout(function () {
                if (atcText) atcText.textContent = atcDefault;
              }, 2000);
              refreshCartUI();
            })
            .catch(function () {
              if (atcText) atcText.textContent = 'Error — try again';
              setTimeout(function () {
                if (atcText) atcText.textContent = atcDefault;
              }, 2500);
            });
        });
      }

      /* Shop the Look progress bar */
      var track = root.querySelector('[data-esla-stl-track]');
      var bar = root.querySelector('[data-esla-stl-bar]');
      if (track && bar) {
        var update = function () {
          var max = track.scrollWidth - track.clientWidth;
          var ratio = track.clientWidth / track.scrollWidth;
          bar.style.width = Math.max(ratio * 100, 12) + '%';
          var progress = max > 0 ? track.scrollLeft / max : 0;
          bar.style.transform = 'translateX(' + progress * (100 / Math.max(ratio, 0.12) - 100) + '%)';
        };
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      }

      /* ── Shop the Look quick add ── */
      var qaModal = root.querySelector('[data-esla-qamodal]');
      var qaList = qaModal ? qaModal.querySelector('[data-esla-qa-list]') : null;

      function qaClose() {
        if (qaModal) qaModal.hidden = true;
      }

      if (qaModal) {
        qaModal.querySelectorAll('[data-esla-qa-close]').forEach(function (el) {
          el.addEventListener('click', qaClose);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') qaClose();
        });
      }

      /* ── Size chart modal ── */
      var scModal = root.querySelector('[data-esla-scmodal]');
      function scClose() {
        if (scModal) scModal.hidden = true;
      }
      if (scModal) {
        root.querySelectorAll('[data-esla-sizechart]').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            scModal.hidden = false;
          });
        });
        scModal.querySelectorAll('[data-esla-sc-close]').forEach(function (el) {
          el.addEventListener('click', scClose);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') scClose();
        });
      }

      root.querySelectorAll('[data-esla-qa]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var holder = btn.closest('.esla-stl__imgwrap');
          var jsonEl = holder ? holder.querySelector('[data-esla-stl-json]') : null;
          if (!jsonEl || !qaModal || !qaList) return;
          var data;
          try {
            data = JSON.parse(jsonEl.textContent);
          } catch (err) {
            return;
          }

          /* single default variant → add straight away, no modal */
          if (data.variants.length === 1 && data.variants[0].label === 'Default Title') {
            addVariantToCart(data.variants[0].id);
            return;
          }

          qaList.innerHTML = '';
          data.variants.forEach(function (v) {
            var row = document.createElement('button');
            row.type = 'button';
            row.className = 'esla-qa-row' + (v.available ? '' : ' is-soldout');

            var label = document.createElement('span');
            label.textContent = v.label;
            row.appendChild(label);

            var note = document.createElement('span');
            note.className = 'esla-qa-note';
            if (v.note) note.textContent = '- ' + v.note;
            row.appendChild(note);

            if (v.available) {
              row.addEventListener('click', function () {
                note.textContent = '- Adding…';
                addVariantToCart(
                  v.id,
                  function () {
                    note.textContent = '- Added ✓';
                    setTimeout(qaClose, 700);
                  },
                  function () {
                    note.textContent = '- Error, try again';
                  }
                );
              });
            } else {
              row.disabled = true;
            }
            qaList.appendChild(row);
          });

          qaModal.hidden = false;
        });
      });

      /* ── Order-by countdown blocks ── */
      root.querySelectorAll('[data-esla-countdown]').forEach(function (el) {
        var cutoff = parseInt(el.dataset.cutoff, 10);
        var out = el.querySelector('[data-esla-count]');
        if (isNaN(cutoff) || !out) return;
        function tick() {
          var now = new Date();
          var end = new Date(now);
          end.setHours(cutoff, 0, 0, 0);
          var diff = end - now;
          if (diff <= 0) {
            el.style.display = 'none';
            return;
          }
          var h = Math.floor(diff / 3600000);
          var m = Math.floor((diff % 3600000) / 60000);
          var s = Math.floor((diff % 60000) / 1000);
          out.textContent = (h > 0 ? h + 'h ' : '') + m + 'm ' + s + 's';
        }
        tick();
        setInterval(tick, 1000);
      });

      /* smooth-scroll for "Fit & Description" link */
      root.querySelectorAll('[data-esla-scrollto]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          var target = document.querySelector(a.getAttribute('href'));
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            var first = target.querySelector('details');
            if (first) first.open = true;
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["esla-welcome-popup"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-wpop]').forEach(function (pop) {
    var key = pop.dataset.key;
    var days = parseInt(pop.dataset.days, 10) || 30;
    var delay = (parseFloat(pop.dataset.delay) || 0) * 1000;
    var designMode = pop.hasAttribute('data-design-mode');
    var posted = pop.hasAttribute('data-posted');

    function seen() {
      try {
        var until = localStorage.getItem(key);
        return until && Date.now() < parseInt(until, 10);
      } catch (e) {
        return false;
      }
    }

    function markSeen() {
      try {
        localStorage.setItem(key, String(Date.now() + days * 86400000));
      } catch (e) {}
    }

    function open() {
      pop.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    function close() {
      pop.hidden = true;
      document.documentElement.style.overflow = '';
      markSeen();
    }

    pop.querySelectorAll('[data-wpop-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    var cta = pop.querySelector('[data-wpop-cta]');
    if (cta) cta.addEventListener('click', markSeen);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !pop.hidden) close();
    });

    if (designMode) {
      /* in the theme editor: open when the section is selected */
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target.contains(pop)) open();
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target.contains(pop)) {
          pop.hidden = true;
          document.documentElement.style.overflow = '';
        }
      });
      return;
    }

    if (posted) {
      /* newsletter just submitted → reopen to show the success message */
      open();
      markSeen();
      return;
    }

    if (seen()) return;
    setTimeout(open, delay);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
